/** String'i integer kuruşa çevir. "1234.56" → 123456 */
export function toKurus(value: string | number | null | undefined): number {
  if (value === null || value === undefined || value === "") return 0;
  const str =
    typeof value === "number" ? value.toString() : value.replace(",", ".");
  const num = parseFloat(str);
  if (isNaN(num)) return 0;
  return Math.round(num * 100);
}

/** Kuruşu string'e çevir. 123456 → "1234.56" */
export function toTL(kurus: number): string {
  return (kurus / 100).toFixed(2);
}

/** Toplama */
export function addMoney(
  ...values: (string | number | null | undefined)[]
): string {
  return toTL(values.reduce<number>((sum, v) => sum + toKurus(v), 0));
}

/** Çıkarma: a - b */
export function subtractMoney(
  a: string | number,
  b: string | number,
): string {
  return toTL(toKurus(a) - toKurus(b));
}

/** Çarpma: amount × quantity */
export function multiplyMoney(
  amount: string | number,
  quantity: string | number,
): string {
  const qty =
    typeof quantity === "string" ? parseFloat(quantity) || 0 : quantity;
  return toTL(Math.round(toKurus(amount) * qty));
}

/** Vergi hesapla: base × rate / 100 */
export function calculateTax(
  base: string | number,
  ratePercent: string | number,
): string {
  const rate =
    typeof ratePercent === "string" ? parseFloat(ratePercent) || 0 : ratePercent;
  return toTL(Math.round((toKurus(base) * rate) / 100));
}

function toRateNumber(ratePercent: string | number): number {
  return typeof ratePercent === "string" ? parseFloat(ratePercent) || 0 : ratePercent;
}

function calculateVatFromGrossKurus(grossKurus: number, ratePercent: string | number): number {
  const rate = toRateNumber(ratePercent);
  if (rate <= 0) return 0;
  return Math.round((grossKurus * rate) / (100 + rate));
}

/** KDV Dahil (Brüt) tutardan KDV Hariç (Net) matrah hesapla
 * Formül: Matrah = Brüt Tutar / (1 + KDV Oranı / 100)
 */
export function calculateNetFromGross(
  grossAmount: string | number,
  vatRatePercent: string | number,
): string {
  const grossKurus = toKurus(grossAmount);
  const vatKurus = calculateVatFromGrossKurus(grossKurus, vatRatePercent);
  const netKurus = grossKurus - vatKurus;
  return toTL(netKurus);
}

/** KDV Dahil (Brüt) tutardan KDV tutarını hesapla
 * Formül: KDV = Brüt Tutar - Matrah
 */
export function calculateVatFromGross(
  grossAmount: string | number,
  vatRatePercent: string | number,
): string {
  const grossKurus = toKurus(grossAmount);
  const vatKurus = calculateVatFromGrossKurus(grossKurus, vatRatePercent);
  return toTL(vatKurus);
}

/** Eşitlik karşılaştırma */
export function moneyEqual(
  a: string | number,
  b: string | number,
): boolean {
  return toKurus(a) === toKurus(b);
}

/** İşaret değiştir */
export function negateMoney(value: string | number): string {
  return toTL(-toKurus(value));
}

/** Tevkifat oranı fraction string'ini parse eder. "2/10" → { numerator: 2, denominator: 10 } */
export function parseTevkifatOrani(oran: string): {
  numerator: number;
  denominator: number;
} {
  const parts = oran.split("/");
  return {
    numerator: parseInt(parts[0]) || 0,
    denominator: parseInt(parts[1]) || 1,
  };
}

/** Tevkifatlı KDV hesapla: (matrah × kdvOran / 100) × (1 - numerator/denominator)
 *  Kuruş hassasiyetinde integer math ile çalışır.
 */
export function calculateTevkifatliKdv(
  matrah: string | number,
  kdvOranPercent: string | number,
  tevkifatOrani: string,
): string {
  const matrahKurus = toKurus(matrah);
  const rate =
    typeof kdvOranPercent === "string"
      ? parseFloat(kdvOranPercent) || 0
      : kdvOranPercent;
  const { numerator, denominator } = parseTevkifatOrani(tevkifatOrani);
  const fullKdvKurus = Math.round((matrahKurus * rate) / 100);
  const tevkifatliKdvKurus = Math.round(
    (fullKdvKurus * (denominator - numerator)) / denominator,
  );
  return toTL(tevkifatliKdvKurus);
}

/** Türkçe görüntüleme: "1234.56" → "1.234,56" */
export function formatTRY(
  value: string | number | null | undefined,
): string {
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(toKurus(value) / 100);
}
